export default __webpack_public_path__ + "0fa6f0b599341210aaf77ce8c08f14c1.png";